// extracted by mini-css-extract-plugin
export default {"Title":"NotFound_Title__A19HI","Root":"NotFound_Root__9oOsU","Icon":"NotFound_Icon__CrCXq","Description":"NotFound_Description__g0mMx"};